
import React, { useContext } from 'react';
import PlayerRightTop from "./PlayerRightTop";
import { Outlet } from "react-router-dom";
import { Card } from "antd";
import { DarkModeContext } from "../../shared/contexts/darkModeContext";
import './playerRight.scss';

const PlayerRight = () => {
    const { darkMode } = useContext(DarkModeContext);

    return (
        <div className={`player-right-container ${darkMode ? 'dark-theme' : 'light-theme'}`}>
            <div className="player-right-content">
                <PlayerRightTop />
                <Card
                    className={`player-right-top-card ${darkMode ? 'dark-theme' : 'light-theme'}`}
                    styles={{
                        header: {
                            borderBottom: `1px solid var(--border-color)`,
                            background: `var(--header-background)`,
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px'
                        },
                        body: {
                            padding: '20px 24px',
                            background: `var(--card-background)`
                        }
                    }}
                    style={{
                        borderRadius: '8px',
                        border: `1px solid var(--border-color)`,
                        background: `var(--card-background)`,
                        boxShadow: 'var(--card-shadow)'
                    }}
                >
                    <Outlet />
                </Card>
            </div>
        </div>
    );
};

export default PlayerRight;